import { createContext, useContext, useState } from "react";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [count, setCount] = useState(0);

    const increment = () => setCount((prev) => prev + 1);
    const reset = () => setCount(0);

    return (
        <NotificationContext.Provider value={{ count, increment, reset }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationContext);
